export const fontOptions = [
    { label: 'Roboto', value: 'Roboto, sans-serif', style: { fontFamily: 'Roboto, sans-serif' } },
    { label: 'Open Sans', value: 'Open Sans, sans-serif', style: { fontFamily: 'Open Sans, sans-serif' } },
    { label: 'Lato', value: 'Lato, sans-serif', style: { fontFamily: 'Lato, sans-serif' } },
    { label: 'Montserrat', value: 'Montserrat, sans-serif', style: { fontFamily: 'Montserrat, sans-serif' } },
    { label: 'Poppins', value: 'Poppins, sans-serif', style: { fontFamily: 'Poppins, sans-serif' } },
    { label: 'Nunito', value: 'Nunito, sans-serif', style: { fontFamily: 'Nunito, sans-serif' } },
    { label: 'Playfair Display', value: 'Playfair Display, serif', style: { fontFamily: 'Playfair Display, serif' } },
    { label: 'Merriweather', value: 'Merriweather, serif', style: { fontFamily: 'Merriweather, serif' } },
    { label: 'Dancing Script', value: 'Dancing Script, cursive', style: { fontFamily: 'Dancing Script, cursive' } },
    { label: 'Pacifico', value: 'Pacifico, cursive', style: { fontFamily: 'Pacifico, cursive' } },
    // Add more fonts as needed
];